<template>
  <v-data-table
    data-app
    class="tabela-justificativas"
    :items="formattedItems"
    :headers="headers"
    :items-per-page="-1"
    hide-default-footer
  >
    <template v-slot:item="{ item }">
      <tr class="table-v-tr" :class="{ 'row-erro': errosItem(item).length }" style="cursor: default">
        <td
          v-for="col in headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          <div
            v-if="col.value === 'razao_social'"
            class="d-flex text-truncate"
            style="min-width: 250px"
            :title="item.razao_social || item.nome"
          >
            <v-tooltip bottom v-if="errosItem(item).length">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-on="on"
                  v-bind="attrs"
                  class="indicador-erro"
                  data-testid="indicador-erro-linha"
                ></div>
              </template>
              <div v-for="(erro, i) in errosItem(item)" :key="i">{{ erro }}</div>
            </v-tooltip>
            <span>{{ item.razao_social || item.nome }}</span>
          </div>

          <div
            v-else-if="col.value === 'cnpj'"
            class="text-truncate"
            style="min-width: 250px"
          >
            <span v-if="item.isCnpj || (item.agrupamento_key && item.cnpj)">{{ item.cnpj | toCNPJ }}</span>
            <span v-else-if="item.cnpj">{{ item.cnpj | toCPF }}</span>
            <span v-else-if="item.agrupamento_key">Agrupado</span>
            
            <div
              v-if="item.isCnpj && (!item.cnpj || (item.cnpj.length !== 14 && item.cnpj.length !== 18))"
              style="color: red; font-size: 10px"
            >
              CNPJ do terceiro está inválido.
            </div>
            <div
              v-else-if="!item.isCnpj && (!item.cnpj || (item.cnpj.length !== 11 && item.cnpj.length !== 14))"
              style="color: red; font-size: 10px"
            >
              CPF do terceiro está inválido.
            </div>
            <div
              v-else-if="item.isCnpj && item.hasDuplicidades && trabalho !== 2"
              style="color: red; font-size: 10px"
            >
              CNPJ do terceiro está duplicado no projeto.
            </div>
            <div
              v-else-if="!item.isCnpj && item.hasDuplicidades && trabalho !== 2"
              style="color: red; font-size: 10px"
            >
              CPF do terceiro está duplicado no projeto.
            </div>
          </div>

          <div
            v-else-if="col.value === 'enquadramento'"
            class="text-truncate"
            style="min-width: 120px"
          >
            <div class="d-flex">
              {{ item.enquadramento ? item.enquadramento : "" }}
            </div>
            <div
              v-if="
                !item.enquadramento ||
                item.enquadramento.length === 0 ||
                opcoesEnquadramentosEmpresas.includes(item.enquadramento)
              "
              style="color: red; font-size: 10px"
            >
              Enquadramento do terceiro está inválido.
            </div>
          </div>

          <v-btn
            v-else-if="col.value === 'notas'"
            color="primary"
            icon
            @click="$emit('open-notas', item.notas, item)"
          >
            <v-icon large>mdi-card-search</v-icon>
          </v-btn>

          <div
            v-else-if="col.value === 'justificativa'"
            :title="item.justificativa"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              <div class="cursor-pointer text-truncate" style="max-width: 300px">
                {{ item.justificativa || "Nenhuma justificativa." }}
              </div>
            </div>
            <div
              v-if="item.justificativa && item.justificativa.length > 1000"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa ultrapassou o limite de caracteres.
            </div>
            <div
              v-else-if="!item.justificativa || item.justificativa.length === 0"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa é obrigatório.
            </div>
          </div>

          <div
            v-else-if="col.value === 'funcao_projeto'"
            :title="item.funcao_projeto"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              <div class="cursor-pointer text-truncate" style="max-width: 300px">
                {{ item.funcao_projeto || "Nenhuma descrição." }}
              </div>
            </div>
            <div
              v-if="item.funcao_projeto && item.funcao_projeto.length > 100"
              style="color: red; font-size: 10px"
            >
              Texto de descrição ultrapassou o limite.
            </div>
          </div>

          <template v-else>
            {{ col.format ? col.format(item[col.value]) : item[col.value] }}
          </template>
        </td>
      </tr>
    </template>
    
    <template v-slot:[`body.append`]="append" v-if="projetoWrapper.total">
      <tr class="table-v-tr">
        <th
          style="cursor: default; font-size: 13px !important"
          v-for="col in append.headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          {{ col.format ? col.format(projetoWrapper.total[col.value]) : projetoWrapper.total[col.value] }}
        </th>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { getErrosTerceiro, opcoesEnquadramentosEmpresas } from "@/core/utils/validacoesJustificativas";

export default {
  name: "TableTerceiros",
  props: {
    projetoWrapper: {
      type: Object,
      required: true,
    },
    trabalho: {
      type: Number,
      required: true,
    },
    somenteErros: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opcoesEnquadramentosEmpresas,
    };
  },
  methods: {
    errosItem(item) {
      return getErrosTerceiro(item, this.trabalho);
    },
  },
  computed: {
    formattedItems() {
      const itens = this.projetoWrapper.terceiros || [];
      if (this.somenteErros) {
        return itens.filter((item) => this.errosItem(item).length);
      }
      return itens;
    },
    headers() {
      const allCols = [
        {
          text: "Fornecedor",
          value: "razao_social",
          width: "14%",
          fixa: true,
          class: "col-fixa",
        },
        {
          text: "CNPJ/CPF",
          value: "cnpj",
          width: "14%",
        },
        {
          text: "Período de consolidação",
          value: "periodo_consolidacao",
          width: "16%",
          show: this.trabalho == 1 ? false : true, // Apenas LI (2) tem Periodo
        },
        {
          text: "Valor",
          value: "valor",
          nowrap: true,
          width: "14%",
          format: (value) => {
            if (value || value == 0) {
              return parseFloat(value).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            }
            return "";
          }
        },
        {
          text: "Descrição",
          value: "funcao_projeto",
          width: "14%",
          show: this.trabalho == 2, // Apenas LI: reutiliza funcao_projeto como "Descrição"
        },
        {
          text: "Justificativa",
          value: "justificativa",
          width: "14%",
        },
        {
          text: "",
          value: "notas",
          width: "14%",
        },
      ];

      return allCols.filter(({ show }) => show !== false);
    },
  },
};
</script>

<style scoped>
.table-v-tr:hover {
  background-color: #f5f5f5;
}
.row-erro {
  background-color: #fff5f5;
}
.indicador-erro {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 100%;
  margin-right: 5px;
  margin-top: 4px;
  flex-shrink: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.nowrap {
  white-space: nowrap;
}
</style>
